import { CircleLayerSpecification, FillLayerSpecification, LineLayerSpecification, SymbolLayerSpecification } from 'mapbox-gl';

export const lineLayerStyle = (): LineLayerSpecification => {
    return {
        id: 'lines',
        source: 'lines',
        type: 'line',
        paint: {
            //'line-color': ['get', 'color'],
            // 'line-color': [
            //     'case',
            //     ['==', ['get', 'signalActivity'], 'Under Way'],
            //     '#1E503E',
            //     ['==', ['get', 'portActivity'], 'Stopped (at anchor)'],
            //     '#DF6721',
            //     ['==', ['get', 'portActivity'], 'Stopped (moored)'],
            //     '#F0D035',
            //     '#819391',
            // ],
            'line-color': '#00355f',
            //"line-dasharray": [3, 3],
            'line-width': 1,
        },
    }
};

export const pointArrowLayerStyle = (zoomLevel: number): SymbolLayerSpecification => {
    return {
        id: 'vessel-arrows',
        source: 'points',
        type: 'symbol',
        layout: {
            'icon-image': ['concat', 'arrow-', ['get', 'color']], // Dynamically use the arrow icon with color
            'icon-size': zoomLevel * 0.08,
            'icon-rotate': ['get', 'heading'],
            'icon-allow-overlap': true,
            'icon-ignore-placement': true,
        },
    };
};

export const arrowLayerStyle = (): SymbolLayerSpecification => {
    return {
        id: 'arrows',
        source: 'lines',
        type: 'symbol',
        layout: {
            'symbol-placement': 'line', // Places symbols along the line
            'symbol-spacing': 50, // Distance between arrows
            'icon-image': 'arrow-icon', // Reference your arrow icon
            'icon-size': 2,
            //'icon-rotate': ['get', 'bearings'], // Optional: rotates based on line direction

            'icon-allow-overlap': true,
            'icon-ignore-placement': true,
        },
    };
};

export const pointArrowLayerStyleForVoyage = (): SymbolLayerSpecification => {
    return {
        id: 'vessel-arrows-for-voyage',
        source: 'voyageDailySignals',
        type: 'symbol',
        layout: {
            'icon-image': 'arrow-icon',
            //'icon-size': .1,
            'icon-size': .1,
            'icon-rotate': ['get', 'heading'],
            'icon-allow-overlap': true,
            //'icon-ignore-placement': true,
        },
    };
};

export const stoppagesLayerStyle: CircleLayerSpecification = {
    id: 'stoppages',
    source: 'stoppages',
    type: 'circle',
    paint: {
        'circle-radius': 10,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': 1,
        'circle-opacity': 0.5,
        'circle-color': [
            'case',
            ['==', ['get', 'vesselActivity'], 'Stopped (Unclassified)'],
            '#819391',
            ['==', ['get', 'vesselActivity'], 'Stopped (at anchor)'],
            '#00355f',
            ['==', ['get', 'vesselActivity'], 'Stopped (moored)'],
            '#F0D035',
            '#819391',
        ],
    },
};

export const portCallsLayerStyle = (): CircleLayerSpecification => {
    return {
        id: 'portCalls',
        source: 'portCalls',
        type: 'circle',
        paint: {
            'circle-radius': 15,
            'circle-color': [
                'case',
                ['==', ['get', 'portActivity'], 'Load'],
                '#569FD3',
                ['==', ['get', 'portActivity'], 'Discharge'],
                '#DF6721',
                ['==', ['get', 'portActivity'], 'In Shipyard'],
                '#F0D035',
                ['==', ['get', 'portActivity'], 'In Shipbreaker'],
                '#F0D035',
                '#819391',
            ], // Gets color from the layer data source
            //'circle-stroke-color': '#ffffff',
            //'circle-stroke-width': 1,
            'circle-opacity': 0.5,
        },
    }
};

export const pointLayerStyle = (zoomLevel: number): CircleLayerSpecification => {
    return {
        id: 'points',
        source: 'points',
        type: 'circle',
        paint: {
            'circle-radius': zoomLevel * 1.75,
            // 'circle-color': [
            // 	'case',
            // 	['<', ['get', 'speed'], 1],
            // 	'#facc15', // Color when 'speed' > 1
            // 	'#0f944c', // Default color if none of the conditions match
            // ],
            'circle-color': ['get', 'color'],
        },
    }
};

export const lineLayerStyleForDailyPositions = (): LineLayerSpecification => {
    return {
        id: 'lineLayerStyleForDailyPositions',
        source: 'vesselDailyPositionsAsLine',
        type: 'line',
        paint: {
            //'line-color': ['get', 'color'],
            // 'line-color': [
            //     'case',
            //     ['==', ['get', 'signalActivity'], 'Under Way'],
            //     '#1E503E',
            //     ['==', ['get', 'portActivity'], 'Stopped (at anchor)'],
            //     '#DF6721',
            //     ['==', ['get', 'portActivity'], 'Stopped (moored)'],
            //     '#F0D035',
            //     '#819391',
            // ],
            'line-color':'#00355f',
            "line-dasharray": [2, 2],
            'line-width': 1,
        },
    }
};

export const pointArrowLayerStyleForDailyPostitons = (): SymbolLayerSpecification => {
    return {
        id: 'vessel-arrows-for-daily-positions',
        source: 'vesselDailyPositions',
        type: 'symbol',
        layout: {
            'icon-image': 'arrow-icon-long',
            'icon-size': .09,
            // 'icon-size': [
            //     'case',
            //     ['==', ['get', 'voyageId'], focusedVoyageId], // Check if the current voyage_id matches the focused one
            //     .16, // Increase the width (e.g., 3 for focused)
            //     .1 // Default width for all other lines
            // ],
            'icon-rotate': ['get', 'heading'],
            'icon-allow-overlap': true,
        },
    };
};

export const pointArrowLayerStyleForOngoingVoyage = (): SymbolLayerSpecification => {
    return {
        id: 'vessel-arrows-for-ongoing-voyage',
        source: 'vesselOngoingVoyageDailySignals',
        type: 'symbol',
        layout: {
            'icon-image': 'arrow-icon',
            'icon-size': .1,
            'icon-rotate': ['get', 'heading'],
            'icon-allow-overlap': true,
            //'icon-ignore-placement': true,
        },
    };
};

export const polygonLayerStyle: FillLayerSpecification = {
    id: 'polygons',
    source: 'polygons',
    type: 'fill',
    paint: {
        'fill-color': '#068',
        'fill-opacity': 0.75,
    },
};